import { ChartData } from 'chart.js';
import { GenericChart, GenericChartProps } from 'app/agriculture/charts/GenericChart/GenericChart';
import { Line } from 'react-chartjs-2';
import { getGenericSparkChartOptions } from 'app/agriculture/charts/GenericSparkChart/GenericSparkChartOptions';
import { useGenericSparkChartValue } from 'app/agriculture/charts/GenericSparkChart/useGenericSparkChartValue';
import { genericSparkChartBackgroundColor } from 'app/agriculture/charts/GenericSparkChart/genericSparkChartBackgroundColor';
import './GenericSparkChart.scss';
import { EmptySparkChart } from 'app/agriculture/charts/EmptySparkChart/EmptySparkChart';
import { ChartContext } from 'app/agriculture/charts/ChartContextProvider';
import { useContext } from 'react';
import { primaryColourMain } from 'app/agriculture/material';

export function GenericSparkChart({
    title,
    displayUnit: unit,
    showCurrentValue,
    data,
}: GenericChartProps) {
    const { intervalUnit } = useContext(ChartContext);
    const values = Object.values(data);
    const currentValue = useGenericSparkChartValue(data);
    const chartIsEmpty = values.every((value) => isNaN(value));

    const chartData: ChartData<'line'> = {
        labels: Object.keys(data).map((ts) => new Date(ts)),
        datasets: [
            {
                data: values,
                // @ts-expect-error the type is a bit broken. Not sure why.
                fill: genericSparkChartBackgroundColor,
                pointStyle: 'circle',
                spanGaps: false,
                borderColor: primaryColourMain,
                pointRadius: 0,
                pointBorderWidth: 3,
                pointBorderColor: 'white',
                pointBackgroundColor: primaryColourMain,
                tension: 0,
            },
        ],
    };

    const defaultChartOptions = getGenericSparkChartOptions({
        intervalUnit: intervalUnit,
    });

    const value = typeof currentValue === 'number' ? `${currentValue}${unit}` : '-';

    return (
        <div className="GenericSparkChart">
            {chartIsEmpty ? (
                <EmptySparkChart title={title} />
            ) : (
                <GenericChart title={title} currentValue={showCurrentValue === true ? value : null}>
                    <Line data={chartData} options={defaultChartOptions} />
                </GenericChart>
            )}
        </div>
    );
}
